<div class="o-step-indicator__step" role="presentation">
  <button
    class="o-step-indicator__step-button"
    role="tab"
    tabindex="0"
    type="button"
    [attr.aria-expanded]="item.active"
    [attr.aria-controls]="item.active ? 'content-' + item.id : null"
    [attr.id]="'nav-' + item.id"
    [disabled]="item.disabled"
    [class.o-step-indicator__step-button--is-active]="item.active"
    (click)="select(item)"
    >
    <span class="o-step-indicator__button-flex">
      <span class="o-step-indicator__step-text">
        {{ item.title }}
      </span>
      @if (item.icon) {
        <span class="o-step-indicator__suffix">
          <ng-container *ngTemplateOutlet="item.icon"> </ng-container>
        </span>
      }
    </span>
  </button>
</div>
